module.exports = __webpack_public_path__ + "img/fourIm.4480d84c.png";